import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { showModal } from '../../../../actions/ModalActions';
import { getPois, editPoi } from '../../../../actions/website/entities/PoiActions';
import { moveEntity, resetEntities, addEntity } from '../../../../actions/website/EntityActions';
import Address from '../../../common/ui/Address';
import EntityHeader from './EntityHeader';
import DragHandle from '../../../common/ui/DragHandle';
import { togglePage } from '../../../../actions/website/PageActions';

class Pois extends Component {
  componentDidMount() {
    const { getPoiEntities } = this.props;
    getPoiEntities();
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  render() {
    const { pois, orderedIds, openModal, onEdit, onDelete, page, themeKey, onPageToggle } = this.props;
    return (
      <div>
        {themeKey && <EntityHeader onAdd={openModal} entityName={'Recommendation'} page={page} themeKey={themeKey} onPageToggle={onPageToggle} />}
        <ul className="sortable-list">
          {pois && orderedIds.map((poiId, index) => (
            <Poi key={poiId} onDelete={onDelete} onEdit={onEdit} poi={pois[poiId]} index={index} />
          ))}
        </ul>
      </div>
    );
  }
}

Pois.propTypes = {
  pois: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getPoiEntities: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
};

const Poi = SortableElement(({ poi, onEdit, onDelete }) => {
  const noPropagate = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  return (
    <li className="sortable-item editable-entity" onClick={() => onEdit(poi)}>
      <div className="col-sm-1">
        <DragHandle tooltip="Drag to reorder" />
      </div>
      <div className="col-sm-8">
        <span className="title">{poi.title}</span>
        <Address address1={poi.address_1} address2={poi.address2} city={poi.city} state={poi.state_province} zip={poi.postal_code} countryCode={poi.country_code} singleLine />
      </div>
      <div className="col-sm-3 entity-actions" onClick={noPropagate}>
        <button onClick={() => onEdit(poi)} title="Edit Recommendation" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Edit"><i className="glyphicon glyphicon-pencil" /></button>
        <button onClick={() => onDelete(poi)} title="Delete Recommendation" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Delete"><i className="glyphicon glyphicon-trash" /></button>
      </div>
    </li>
  );
});

Poi.propTypes = {
  poi: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number
};

const mapStateToProps = state => (
  {
    pois: state.website.entities.byId,
    orderedIds: state.website.entities.orderedIds,
    page: state.website.pages.byId[state.website.pages.typeToId.POI],
    themeKey: state.wedding.theme.key,
    showMap: state.wedding.account.enable_poi_maps
  }
);

const mapDispatchToProps = dispatch => (
  {
    onSortEnd: ({ oldIndex, newIndex }) => {
      dispatch(moveEntity(oldIndex, newIndex));
    },
    openModal: () => {
      dispatch(addEntity());
      dispatch(showModal('POI', {}, { size: 'md' }));
    },
    getPoiEntities: () => {
      dispatch(getPois());
    },
    onEdit: (poi) => {
      dispatch(editPoi(poi));
      dispatch(showModal('POI', { isUpdate: true }, { size: 'md' }));
    },
    onDelete: (entity) => {
      dispatch(showModal('DELETE_ENTITY', { entity }));
    },
    unloadEntities: () => {
      dispatch(resetEntities());
    },
    onPageToggle: pageId => dispatch(togglePage(pageId)),
  }
);

const SortablePois = SortableContainer(Pois);

const PoiContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SortablePois);

export default PoiContainer;



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/Pois.jsx
 **/